export const locale = {
    lang: 'fr',
    data: {
        PLACE: 'Où souhaitez-vous placer ces listes?',
        ACTIVITY: 'Activité',
        CANCEL: 'Annuler',
        SAVE: 'Enregistrer',
    }
};
